import React from "react";

export default ({email}) => <a target="_blank" href={"mailto:" + email}>{email}</a>